import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM } from '../../../../../constants'
import { getFeatureFromCache } from '../../../../../util/feature-cache'
import { LineItemFulfilmentNote as LineItemFulfilmentNoteUnified } from './LineItemFulfilmentNote'
import { LineItemFulfilmentNoteLegacy } from './LineItemFulfilmentNoteLegacy'
import type { LineItemFulfilmentNoteProps } from './useLineItemFulfilmentNoteModel'

export const LineItemFulfilmentNote: React.FC<LineItemFulfilmentNoteProps> = props => {
  const isUnifiedFulfilmentUiEnabled = getFeatureFromCache(
    FEATURE_UC_IN_WEBREGISTER_LINE_ITEM
  )

  return isUnifiedFulfilmentUiEnabled ? (
    <LineItemFulfilmentNoteUnified {...props} />
  ) : (
    <LineItemFulfilmentNoteLegacy {...props} />
  )
}
